<div
  class="linear-indicator"
  role="progressbar"
  [attr.aria-valuemin]="0"
  [attr.aria-valuemax]="100"
  [attr.aria-valuenow]="isIndeterminate ? null : clampedPercentage"
  [attr.aria-busy]="isIndeterminate"
>
  <div class="linear-indicator__track"></div>

  @if (isIndeterminate) {
    <div class="linear-indicator__progress linear-indicator__progress--indeterminate"></div>
  } @else {
    <div class="linear-indicator__progress" [style.width.%]="clampedPercentage"></div>
  }
</div>
